import * as Yup from 'yup';

export const initialValues = (formik, item) => {
  if(!formik) return;
  
  let myId = 0;
  if (item != null && (Object.keys(item).length > 0 || item.constructor !== Object)) {
    myId = item.id;
  }

  formik.setFieldValue('id', myId);
  formik.setFieldValue('name', null);
  formik.setFieldValue('group', null);
  formik.setFieldValue('locationField', null);
};

export const validationSchema = (item) => {
  const isCreate = item?.isCreate;
  return Yup.object().shape({
    name: isCreate
      ? Yup.string().required('Vui lòng nhập tên nhóm')
      : Yup.string().nullable(),
    group: Yup.object().required('Vui lòng chọn nhóm'),
    locationField: isCreate
      ? Yup.object().required('Vui lòng chọn địa chỉ')
      : Yup.object().nullable(),
  });
};


export const handleSubmitted = async (
  values,
  item,
  apiCreate,
  apiDelete,
  apiUpdate,
) => {
  const isCreate = values.group?.value > 0;
  if (isCreate) {
    await apiCreate(values);
  } else {
    if (values.isVerified) {
      await apiDelete(values);
    } else {
      await apiUpdate(values);
    }
  }
};
